import Model from "./Model";
import Cookies from "../utils/Cookies";

export default class AssemblyParameters extends Model {

	constructor(props) {

		super({});

		this.setDefaultValues({
			general: {
				dark: Cookies.get('polymind-dark') === 'true',
				speech: Cookies.get('polymind-speech') === 'true',
				sound: Cookies.get('polymind-sound') === 'true',
			},
			component: {},
			dataset: {},
		}, props);
	}
}
